import style from "./style.css";

const IconBorder = ({
  imgSrc,
  bgWidth,
  bgHeight,
  iconWidth,
  iconHeight,
  framePadding,
  isLoading,
}) => (
  <div class={style.icon_frame_border} style={{ padding: `${framePadding}px` }}>
    <div
      class={isLoading ? style.icon_frame_loading : style.icon_frame}
      style={{ width: `${bgWidth}px`, height: `${bgHeight}px` }}
    >
      <img
        class={style.image}
        style={{ maxWidth: `${iconWidth}px`, maxHeight: `${iconHeight}px` }}
        alt=""
        src={imgSrc}
      />
    </div>
  </div>
);

export default IconBorder;
